<template>
  <b-sidebar
    id="add-new-user-sidebar"
    :visible="isAddNewUserSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    width="50%"
    @hidden="resetForm"
    @change="val => $emit('update:is-add-new-user-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">
          Lisää uusi työntekijä
        </h5>

        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
      </div>

      <!-- BODY -->
      <validation-observer ref="simpleRules">
        <!-- Form -->
        <b-form class="p-2">
          <b-row>
            <!-- First name -->
            <b-col class="md-6">
              <validation-provider #default="{ errors }" name="Etunimi" rules="required">
                <b-form-group :label="$t('firstName')" label-for="first-name">
                  <b-form-input
                    id="first-name"
                    v-model="userData.firstName"
                    autofocus
                    :state="errors.length > 0 ? false:null"
                    trim
                    placeholder=""
                  />

                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- Last name -->
            <b-col class="md-6">
              <validation-provider
                #default="{ errors }"
                name="Last name"
                rules="required|alpha-num"
              >
                <b-form-group :label="$t('lastName')" label-for="last-name">
                  <b-form-input
                    id="last-name"
                    v-model="userData.lastName"
                    :state="errors.length > 0 ? false:null"
                    trim
                  />

                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <b-row>
            <!-- Email -->
            <b-col class="md-6">
              <validation-provider #default="{ errors }" name="Email" rules="required|email">
                <b-form-group :label="$t('email')" label-for="email">
                  <b-form-input
                    id="email"
                    v-model="userData.email"
                    :state="errors.length > 0 ? false:null"
                    trim
                  />

                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- Mobile -->
            <b-col class="md-6">
              <validation-provider #default="{ errors }" name="Phone" rules="required">
                <b-form-group :label="$t('mobile')" label-for="phone">
                  <b-form-input
                    id="phone"
                    v-model="userData.mobile"
                    type="number"
                    :state="errors.length > 0 ? false:null"
                    trim
                  />

                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="md-6">
              <validation-provider #default="{ errors }" name="Birthday" rules="required">
                <b-form-group
                  :label="$t('application.addUserModal.labels.birthday')"
                  label-for="birthday"
                >
                  <b-form-input
                    v-model="userData.birthday"
                    placeholder="DD.MM.YYYY"
                    :state="errors.length > 0 ? false:null"
                  />
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col class="md-6" />
          </b-row>

          <br>
          <br>

          <b-row>
            <b-col class="md-6">
              <validation-provider #default="{ errors }" name="Street address" rules="required">
                <b-form-group
                  :label="$t('streetAddress')"
                  label-for="streetAddress"
                >
                  <b-form-input
                    v-model="userData.streetAddress"
                    :state="errors.length > 0 ? false:null"
                  />
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col class="md-6">
              <validation-provider #default="{ errors }" name="City" rules="required">
                <b-form-group
                  :label="$t('city')"
                  label-for="city"
                >
                  <b-form-input
                    v-model="userData.city"
                    :state="errors.length > 0 ? false:null"
                  />
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="md-6">
              <validation-provider #default="{ errors }" name="Postcode" rules="required">
                <b-form-group
                  :label="$t('postcode')"
                  label-for="postcode"
                >
                  <b-form-input
                    v-model="userData.postcode"
                    :state="errors.length > 0 ? false:null"
                  />
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col class="md-6">
              <validation-provider #default="{ errors }" name="State" rules="required">
                <b-form-group
                  :label="$t('state')"
                  label-for="state"
                >
                  <v-select
                    id="state"
                    v-model="userData.state"
                    :options="stateOptions"
                    :reduce="val => val.value"
                    :state="errors.length > 0 ? false:null"
                    :clearable="false"
                    label="label"
                  />
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <br>
          <br>

          <b-row>
            <b-col class="md-6">
              <validation-provider #default="{ errors }" name="Profession" rules="required">
                <b-form-group
                  :label="$t('profession')"
                  label-for="profession"
                >
                  <v-select
                    id="profession"
                    v-model="userData.profession"
                    style="text-transform: capitalize"
                    :state="errors.length > 0 ? false:null"
                    :options="typeReqOptions"
                    :selectable="option => !option.includes('valitse')"
                    :clearable="false"
                    label="text"
                  />
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col class="md-6">
              <validation-provider #default="{ errors }" name="Finnish" rules="required">
                <b-form-group
                  :label="$t('finnish')"
                  label-for="finnish"
                >
                  <v-select
                    id="finnish"
                    v-model="userData.finnish"
                    :state="errors.length > 0 ? false:null"
                    :reduce="val => val.value"
                    :options="finnishLevelOptions"
                    :selectable="option => !option.value.includes('valitse')"
                    :clearable="false"
                    label="label"
                  />
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="md-6">
              <b-form-group
                :label="$t('drivingLicense')"
                label-for="driving-license"
              >
                <v-select
                  id="driving-license"
                  v-model="userData.drivingLicense"
                  :reduce="val => val.value"
                  :options="drivingLicenseOptions"
                  :selectable="option => !option.value.includes('valitse')"
                  label="label"
                  multiple
                />
              </b-form-group>
            </b-col>
            <b-col class="md-6">
              <b-form-group
                :label="$t('languages')"
                label-for="languages"
              >
                <v-select
                  id="languages"
                  v-model="userData.languages"
                  :reduce="val => val.value"
                  :options="languageOptions"
                  :selectable="option => !option.value.includes('valitse')"
                  label="label"
                  multiple
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="6">
              <b-form-group
                :label="$t('application.addUserModal.labels.carAvailable')"
                label-for="car-available"
              >
                <b-form-checkbox
                  v-model="userData.carAvailable"
                  name="car-available"
                  switch
                  inline
                  :state="userData.carAvailable ? true : null"
                >
                  <span class="switch-icon-left">
                    <feather-icon icon="CheckIcon" />
                  </span>
                  <span class="switch-icon-right">
                    <feather-icon icon="XIcon" />
                  </span>
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Country -->
          <!-- <validation-provider #default="validationContext" name="Gender" rules="required">
            <b-form-group
              label="Gender"
              label-for="gender"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="userData.gender"
                :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
                :options="genderOptions"
                :reduce="val => val.value"
                :clearable="false"
                input-id="gender"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider> -->

          <!-- User Role -->
          <!-- <validation-provider #default="validationContext" name="Role" rules="required">
            <b-form-group
              label="Role"
              label-for="user-role"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="userData.role"
                :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
                :options="roleOptions"
                :reduce="val => val.value"
                :clearable="false"
                input-id="user-role"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider> -->

          <!-- Plan -->
          <!-- <validation-provider #default="validationContext" name="Love" rules="required">
            <b-form-group
              label="Love"
              label-for="love"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="userData.love"
                :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
                :options="planOptions"
                :reduce="val => val.value"
                :clearable="false"
                input-id="plan"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider> -->

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              @click="handleSubmit"
            >
              {{ $t('Add') }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              {{ $t('cancel') }}
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BRow,
  BCol,
  BFormCheckbox,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, alphaNum, email } from '@validations'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import i18n from '@hw-core/libs/i18n'
import moment from 'moment'
import countries from '@mock/data/other/countries'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BRow,
    BCol,
    vSelect,
    BFormCheckbox,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewUserSidebarActive',
    event: 'update:is-add-new-user-sidebar-active',
  },
  props: {
    isAddNewUserSidebarActive: {
      type: Boolean,
      required: true,
    },
    roleOptions: {
      type: Array,
      required: true,
    },
    planOptions: {
      type: Array,
      required: true,
    },
    genderOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      required,
      alphaNum,
      email,
      countries,
      userData: {},
    }
  },
  computed: {
    appConfig() {
      return this.$store.state.app.appConfig || {}
    },
    typeReqOptions() {
      return this.$store.state.appAccount.selectedAccount.value.professions || []
    }
  },
  methods: {
    resetForm() {
      this.userData = {}
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          // eslint-disable-next-line
          alert('password reset!')
        }
      })
    },
    handleSubmit() {
      const user = {
        ...this.userData,
        address: {
          city: this.userData.city.toLowerCase(),
          postcode: this.userData.postcode,
          state: this.userData.state,
          streetAddress: this.userData.streetAddress.toLowerCase(),
        },
        role: this.userData.profession,
      }
      delete user.city
      delete user.postcode
      delete user.state
      delete user.streetAddress

      this.$emit('add-user', user)
      this.$emit('update:is-add-new-user-sidebar-active', false)
    }
  },
  setup() {
    const dateFormat = 'DD.MM.YYYY'

    const stateOptions = [
      { label: 'Ahvenanmaa', value: 'ahvenanmaa' },
      { label: 'Etelä-Karjala', value: 'etelä-karjala' },
      { label: 'Etelä-Pohjanmaa', value: 'etelä-pohjanmaa' },
      { label: 'Etelä-Savo', value: 'etelä-savo' },
      { label: 'Kainuu', value: 'kainuu' },
      { label: 'Kanta-Häme', value: 'kanta-häme' },
      { label: 'Keski-Pohjanmaa', value: 'keski-pohjanmaa' },
      { label: 'Keski-Suomi', value: 'keski-suomi' },
      { label: 'Kymenlaakso', value: 'kymenlaakso' },
      { label: 'Lappi', value: 'lappi' },
      { label: 'Pirkanmaa', value: 'pirkanmaa' },
      { label: 'Pohjanmaa', value: 'pohjanmaa' },
      { label: 'Pohjois-Karjala', value: 'pohjois-karjala' },
      { label: 'Pohjois-Pohjanmaa', value: 'pohjois-pohjanmaa' },
      { label: 'Pohjois-Savo', value: 'pohjois-savo' },
      { label: 'Päijät-Häme', value: 'päijät-häme' },
      { label: 'Satakunta', value: 'satakunta' },
      { label: 'Uusimaa', value: 'uusimaa' },
      { label: 'Varsinais-Suomi', value: 'varsinais-suomi' },
    ]

    const finnishLevelOptions = [
      { label: i18n.t('mother_tongue'), value: 'äidinkieli' },
      { label: i18n.t('excellent'), value: 'erinomainen' },
      { label: i18n.t('good'), value: 'hyvä' },
      { label: i18n.t('basic'), value: 'perus' },
      { label: i18n.t('beginner'), value: 'alkeet' },
      { label: i18n.t('no'), value: 'ei' },
    ]

    const languageOptions = [
      { label: 'English', value: 'english' },
      { label: 'Swedish', value: 'swedish' },
      { label: 'Somali', value: 'somali' },
      { label: 'Arabic', value: 'arabic' },
      { label: 'Spanish', value: 'spanish' },
      { label: 'Russian', value: 'russian' },
      { label: 'Mandarin Chinese', value: 'mandarin chinese' },
      { label: 'Estonian', value: 'estonian' },
      { label: 'Italian', value: 'italian' },
      { label: 'Turkish', value: 'turkish' },
      { label: 'Polish', value: 'polish' },
      { label: 'German', value: 'german' },
      { label: 'Dutch', value: 'dutch' },
      { label: 'Czech', value: 'czech' },
    ]

    const drivingLicenseOptions = [
      { label: 'B', value: 'b' },
      { label: 'BE', value: 'be' },
      { label: 'C1', value: 'c1' },
      { label: 'C1E', value: 'c1e' },
      { label: 'C', value: 'c' },
      { label: 'CE', value: 'ce' },
    ]

    const dateInvalid = date => {
      if (!date || moment(date, dateFormat, true).isValid()) {
        return ''
      }
      return 'Päivämäärä pitää olla muodossa, esim: 01.01.1990'
    }

    const onSubmit = () => {
      
    }

    return {
      stateOptions,
      finnishLevelOptions,
      languageOptions,
      drivingLicenseOptions,
      onSubmit,
      dateInvalid,
    }
  },
}
</script>

<style lang="scss">
@import '@hw-ui/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
